import React from 'react'
import TicketComponent from './TicketComponent'

const TicketLayout = ({children}) => {
  return (
    <div>
        {children}
        <TicketComponent />
    </div>
  )
}

export default TicketLayout